import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useTimeTrackingConfigurationDeleteHandler } from '../../../hooks/entity/deleteHandler/useTimeTrackingConfigurationDeleteHandler';
import { EditTimeTrackingConfigurationDialog } from '../EditTimeTrackingConfigurationDialog/EditTimeTrackingConfigurationDialog';
export type TimeTrackingConfigurationListItemProps = CardListItemProps & {
  readonly timeTrackingConfiguration: TimeTrackingConfiguration;
};
export const TimeTrackingConfigurationListItem: FunctionComponent<TimeTrackingConfigurationListItemProps> = props => {
  const $ = _c(22);
  let remainingProps;
  let timeTrackingConfiguration;
  if ($[0] !== props) {
    ({
      timeTrackingConfiguration,
      ...remainingProps
    } = props);
    $[0] = props;
    $[1] = remainingProps;
    $[2] = timeTrackingConfiguration;
  } else {
    remainingProps = $[1];
    timeTrackingConfiguration = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened(t0);
  const handleDeleteClick = useTimeTrackingConfigurationDeleteHandler(timeTrackingConfiguration);
  let t1;
  if ($[4] !== timeTrackingConfiguration.name) {
    t1 = <CardListItemTitle>{timeTrackingConfiguration.name}</CardListItemTitle>;
    $[4] = timeTrackingConfiguration.name;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleDeleteClick) {
    t2 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} />;
    $[6] = handleDeleteClick;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== openEditDialog) {
    t3 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.editInDialogIcon} onClick={openEditDialog} data-testid="TimeTrackingConfigurationListItem.EditButton" />;
    $[8] = openEditDialog;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <CardListItem {...remainingProps}>{t1}{t2}{t3}</CardListItem>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== closeEditDialog || $[16] !== modalProps || $[17] !== timeTrackingConfiguration) {
    t5 = <EditTimeTrackingConfigurationDialog {...modalProps} timeTrackingConfiguration={timeTrackingConfiguration} onAccept={closeEditDialog} data-testid="TimeTrackingConfigurationListItem.EditDialog" />;
    $[15] = closeEditDialog;
    $[16] = modalProps;
    $[17] = timeTrackingConfiguration;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};